import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';
import { insights } from '../../data/site';
export function InsightsPreview() {
  return <section className="bg-mist py-24 lg:py-32" data-id="element-180" data-mp="2qm3que0h4pgo">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-181" data-mp="2vjvh73lh03ir">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end" data-id="element-182" data-mp="3j8eq9lccgkbw">
          <SectionHeading eyebrow="Executive Insights" title="Perspectives on governance, risk, and legal leadership." data-id="element-183" data-mp="3jar5vrumqils" />
          <Reveal delay={0.1} data-id="element-184" data-mp="39hk6qoqhfyu5">
            <Link to="/insights" className="group inline-flex items-center gap-2 text-[0.7rem] uppercase tracking-micro text-royal transition-colors hover:text-gold" data-id="element-185" data-mp="39gis6aa9cu7o">
              All insights
              <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-186" data-mp="asblbncm99r9" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-3" data-id="element-187" data-mp="kwytqcy8wuv">
          {insights.slice(0, 3).map((article, index) => <Reveal key={article.slug} delay={index * 0.07} data-id="element-188" data-mp="acubl1jlvwvp" data-mpi={index}>
              <Link to="/insights" className="group flex h-full flex-col border border-navy/10 bg-white p-8 transition-all duration-500 hover:border-gold/60 hover:shadow-lux" data-id="element-189" data-mp="aedpwmlpbxuu">
                <span className="eyebrow text-[0.6rem] text-gold" data-id="element-190" data-mp="jfbwncniyjh4">{article.category}</span>
                <h3 className="mt-4 font-display text-xl font-normal leading-snug text-navy" data-id="element-191" data-mp="egigtdkrmgds">
                  {article.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-charcoal/70" data-id="element-192" data-mp="occ5fvbre0bx">{article.excerpt}</p>
                <span className="mt-6 flex items-center justify-between border-t border-navy/10 pt-4 text-xs text-charcoal/50" data-id="element-193" data-mp="2v434qzmenjnj">
                  {article.date}
                  <span className="flex items-center gap-1.5 text-royal transition-colors group-hover:text-gold" data-id="element-194" data-mp="3fs4304vta1a1">
                    Read
                    <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-195" data-mp="3juqwsbc1lw9v" />
                  </span>
                </span>
              </Link>
            </Reveal>)}
        </div>
      </div>
    </section>;
}